import {
  CONSTANTS,
  SQUARE_METER_PRICE_HOUSE_WITH_NO_PRICE
} from '@js/common/constants'

import {
  budgetRangeMappedValue,
  mapLivingAreaTotalValueToRange
} from '@f/applications/QuizApp/partials/utils'

import { HouseDetail } from '@f-fertighaus/applications/Next/types/houseDetailsResponse'
import { VendorDetails } from '@f-fertighaus/applications/Next/types/vendorResponse'

import { WIZARD_REQUEST_TYPES, WizardRequestType } from './wizardConstants'

type ConfigByWizardRequestType =
  | {
      funnelValue: 'house-detail'
      selectedInstanceClass: 'house'
      selectedInstancesKey: 'houses'
    }
  | {
      funnelValue: 'vendor-detail'
      selectedInstanceClass: 'vendor'
      selectedInstancesKey: 'vendors'
    }
  | {
      funnelValue: 'outfitter-result'
      selectedInstanceClass: 'outfitter'
      selectedInstancesKey: 'outfitters'
    }
  | {
      funnelValue: 'catalog'
      selectedInstanceClass: 'catalog'
      selectedInstancesKey: 'catalog'
    }

export const getWizardConfigByRequestType = (
  requestType: WizardRequestType
): ConfigByWizardRequestType => {
  if (
    requestType === WIZARD_REQUEST_TYPES.houseDetailFavourite ||
    requestType === WIZARD_REQUEST_TYPES.houseDetailExpose ||
    requestType === WIZARD_REQUEST_TYPES.houseDetailForm ||
    requestType === WIZARD_REQUEST_TYPES.houseDetailGallery ||
    requestType === WIZARD_REQUEST_TYPES.houseListForm
  ) {
    return {
      funnelValue: 'house-detail',
      selectedInstanceClass: 'house',
      selectedInstancesKey: 'houses'
    }
  }

  if (
    requestType === WIZARD_REQUEST_TYPES.vendorDetailForm ||
    requestType === WIZARD_REQUEST_TYPES.vendorDetailOfficesForm
  ) {
    return {
      funnelValue: 'vendor-detail',
      selectedInstanceClass: 'vendor',
      selectedInstancesKey: 'vendors'
    }
  }

  if (requestType === WIZARD_REQUEST_TYPES.outfitter) {
    return {
      funnelValue: 'outfitter-result',
      selectedInstanceClass: 'outfitter',
      selectedInstancesKey: 'outfitters'
    }
  }

  return {
    funnelValue: 'catalog',
    selectedInstanceClass: 'catalog',
    selectedInstancesKey: 'catalog'
  }
}

export const getSelectedInstancesIds = (
  selectedInstances: VendorDetails[] | HouseDetail[]
) => {
  return selectedInstances.map(el => el.nid)
}

type VendorDetailsWithIsPrequal = VendorDetails & { is_prequal: boolean }

export const getHardRequestConfig = (
  isPrequal: boolean,
  vendors: VendorDetailsWithIsPrequal[]
) => {
  return {
    selected_instances: vendors.map(vendor => vendor.nid),
    prequal:
      (!isPrequal && vendors.find(vendor => vendor.is_prequal)) || isPrequal,
    type: 'house-detail-additional',
    funnel: 'house-detail-success',
    selected_instance_class: 'vendor'
  }
}

export const mapHouseOfInterestParams = (houseOfInterest: HouseDetail) => {
  return {
    utilization: houseOfInterest.utilization || null,
    budget_range: budgetRangeMappedValue(
      houseOfInterest.price ||
        houseOfInterest.living_area_total *
          SQUARE_METER_PRICE_HOUSE_WITH_NO_PRICE
    ),
    living_area_total: mapLivingAreaTotalValueToRange(
      houseOfInterest.living_area_total
    ),
    expansion_stage:
      CONSTANTS.expansion_stage.find(
        ({ label }) => label === houseOfInterest.expansion_stage_display
      )?.value || null
  }
}
